(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('provisioning', {
                    parent: 'app.private',
                    url: '/provisioning',
                    data: {
                        pageTitle: 'provisioning.title'
                    },
                    params: {
                        id: {value: null},
                        name: {value: null},
                        type: {value: null},
                        hiddenParam: 'YES'
                    },
                    views: {
                        'content@app.private': {
                            templateUrl: 'app/components/provisioning/provisioning.html',
                            controller: 'ProvisioningController',
                            controllerAs: 'vmProvisioning'
                        },
                        'filter@provisioning': {
                            templateUrl: 'app/components/provisioning/provisioning-filter.html',
                            controller: 'ProvisioningFilterController',
                            controllerAs: 'vmProvisioningFilter'
                        },
                        'bridge@provisioning': {
                            templateUrl: 'app/components/bridge/bridge-list.html',
                            controller: 'BridgeListController',
                            controllerAs: 'vmBridgeList'
                        },
                        'gtp@provisioning': {
                            templateUrl: 'app/components/gtp/gtp-list.html',
                            controller: 'GtpController',
                            controllerAs: 'vmGtp'
                        },
                        'packetRule@provisioning': {
                            templateUrl: 'app/components/packet-rule/packet-rule-list.html',
                            controller: 'PacketRuleListController',
                            controllerAs: 'vmPacketRuleList'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('provisioning');
                                $translatePartialLoader.addPart('bridge');
                                $translatePartialLoader.addPart('gtp');
                                $translatePartialLoader.addPart('packet-rule');
                                return $translate.refresh();
                            }]
                    }
                })
    }

})();
